module.exports = __webpack_public_path__ + "static/img/SB.e5c077e7.png";